import React from 'react';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { Instructions } from './components/Instructions/Instructions';
import { QRCode } from './components/QRCode/QRCode';
import { WebsiteUrlTestEvents } from './components/WebsiteUrlTestEvents/websiteUrlTestEvents';
import styles from './websiteWrapper.module.scss';

export const WebsiteWrapper = () => {
    const { value: pixelTesterUrl } = useFormFieldValue({
        field: 'pixelTesterUrl',
    });

    return (
        <div className={styles['container']}>
            <WebsiteUrlTestEvents />
            {pixelTesterUrl && <QRCode pixelTesterUrl={pixelTesterUrl} />}
            <Instructions />
        </div>
    );
};
